<template>
  <div class="information">
    <div class="info-container">
      <div class="info-breadcrumb">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item class="breadcrumb-text" :to="{ path: '/index/' }"
            >首页</el-breadcrumb-item
          >
          <el-breadcrumb-item
            class="breadcrumb-text"
            :to="{ path: '/club?id=' + this.clubid }"
            >社团</el-breadcrumb-item
          >
          <el-breadcrumb-item class="breadcrumb-text">职务</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="search_box">
        <el-input
          placeholder="请输入名称"
          @clear="clearPageGetData"
          v-model="pageData.search"
          clearable
        >
        </el-input>
        <el-button
          style="margin-left: 20px"
          type="primary"
          @click="clearPageGetData"
          icon="el-icon-search"
          >搜索</el-button
        >
      </div>
      <div class="info-operate" style="margin-bottom: 20px">
        <el-button type="primary" v-if="isshowaddbtn" @click="addIndustry">新增</el-button>
      </div>
      <div class="info-tab">
        <div class="info-table">
          <template>
            <el-table border :data="tableData" style="width: 100%">
              <el-table-column type="selection" width="100"></el-table-column>
              <el-table-column label="ID" prop="id" width="100">
                <!-- <template slot-scope="scope">
                  <el-link type="primary" :href="'clubuserinfo?id=' + scope.row.id + '&clubid=' + clubid">{{scope.row.id}}</el-link>
                </template> -->
              </el-table-column>
              <el-table-column label="名称" prop="name"></el-table-column>
              <el-table-column label="排序" prop="sort"></el-table-column>
              <el-table-column label="操作" v-if="isshoweditbtn || isshowdelbtn" align="center">
                <template slot-scope="scope">
                  <el-button
                    v-if="isshoweditbtn"
                    type="primary"
                    size="mini"
                    @click="handleEdit(scope.row)"
                    >编辑</el-button
                  >
                  <el-button
                    v-if="isshowdelbtn"
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)"
                    >删除</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </template>
          <div class="info-pagination">
            <el-pagination
              background
              layout="prev, pager, next"
              :page-size="pageData.pageNum"
              @current-change="handleCurrentChange"
              :total="totalNum"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 新增职务弹出层 -->
    <el-dialog title="新增职务" :visible.sync="showdialog" width="30%">
      <el-form
        ref="form"
        :rules="linesrules"
        :model="industrysdata"
        label-width="80px"
      >
        <el-form-item label="职务名称" prop="name">
          <el-input v-model="industrysdata.name"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="industrysdata.sort"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="canceldialog">取 消</el-button>
        <el-button type="primary" @click="addBtn">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 编辑职务弹出层 -->
    <el-dialog title="编辑职务" :visible.sync="showeditdialog" width="30%">
      <el-form
        ref="editform"
        :rules="lineseditrules"
        :model="lineeditdata"
        label-width="80px"
      >
        <el-form-item label="职务名称" prop="name">
          <el-input v-model="lineeditdata.name"></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="lineeditdata.sort"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="canceleditdialog">取 消</el-button>
        <el-button type="primary" @click="addeditBtn">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Job",
  data() {
    return {
      clubid: "",
      tableData: [],
      totalNum: 0,
      pageData: {
        currentPage: 1,
        pageNum: 10,
        search: "",
      },
      showdialog: false,
      showeditdialog: false,
      industrysdata: {
        name: "",
        sort: '',
      },
      lineeditdata: {
        id: "",
        name: "",
        sort: '',
      },
      linesrules: {
        name: [
          {
            required: true,
            message: "请输入职务名称",
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          }
        ]
      },
      lineseditrules: {
        name: [
          {
            required: true,
            message: "请输入职务名称",
            trigger: "blur",
          },
        ],
        sort: [
          {
            required: true,
            message: "请输入排序",
            trigger: "blur",
          }
        ]
      },
      isshoweditbtn: true,
      isshowaddbtn: true,
      isshowdelbtn: true
    };
  },
  created() {
    this.clubid = this.$route.query.id;
    this.pageData.id = this.$route.query.id;
    this.getData();
  },

  mounted() {
    if(String(localStorage.getItem('perlist').indexOf('职务管理编辑')) == -1) {
      this.isshoweditbtn = false
    }
    if(String(localStorage.getItem('perlist').indexOf('职务管理新增')) == -1) {
      this.isshowaddbtn = false
    }
    if(String(localStorage.getItem('perlist').indexOf('职务管理删除')) == -1) {
      this.isshowdelbtn = false
    }
  },

  methods: {
    // 控制页面的切换
    handleCurrentChange: function (currentpage) {
      this.pageData.currentPage = currentpage;
      this.getData();
    },

    // 清除page重载列表
    clearPageGetData(){
      this.pageData.page = 1;
      this.getData();
    },

    getData() {
      this.$axios({
        url: "/backend/position_list/",
        methods: "get",
        params: this.pageData,
      })
        .then((res) => {
          if (res.data.success) {
            this.tableData = res.data.data;
            this.totalNum = res.data.total;
          } else {
            this.$message.error(res.data.error);
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },

    // 新增职务
    addIndustry() {
      this.showdialog = true;
    },
    // 取消
    canceldialog() {
      this.showdialog = false;
      this.$refs.form.resetFields();
    },

    //确认新增
    addBtn() {
      let formdata = new FormData();
      formdata.set("club_id", this.clubid);
      formdata.set("name", this.industrysdata.name);
      formdata.set("sort", this.industrysdata.sort);
      this.$axios({
        url: "/backend/position_create/",
        method: "post",
        data: formdata,
      })
        .then((res) => {
          if (res.data.success) {
            this.getData();
            this.showdialog = false;
          } else {
            this.$message.error(res.data.error);
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },

    // 编辑
    handleEdit(e) {
      let id = e.id;
      this.showeditdialog = true;
      this.lineeditdata.id = id;
      this.lineeditdata.name = e.name;
      this.lineeditdata.sort = e.sort;
    },
    // 取消编辑
    canceleditdialog() {
      this.showeditdialog = false;
      this.$refs.editform.resetFields();
    },
    // 确认编辑
    addeditBtn() {
      let formdata = new FormData();
      formdata.append("id", this.lineeditdata.id);
      formdata.append("name", this.lineeditdata.name);
      formdata.append("sort", this.lineeditdata.sort);
      this.$axios({
        url: "/backend/position_change/",
        method: "post",
        data: formdata,
      })
        .then((res) => {
          if (res.data.success) {
            this.getData();
            this.showeditdialog = false;
          } else {
            this.$message.error(res.data.error);
          }
        })
        .catch((error) => {
          this.$message.error(error);
        });
    },

    // 删除
    handleDelete(e, row) {
      let userid = row.id;
      let ids = [];
      ids.push(userid);
      let fromdata = new FormData();
      fromdata.set("ids", JSON.stringify(ids));
      this.$confirm("是否删除此职务?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.$axios({
            url: "/backend/position_delete/",
            method: "post",
            data: fromdata,
          })
            .then((res) => {
              if (res.data.success) {
                this.$message.success("删除成功");
                this.getData();
              } else {
                this.$message.error(res.data.error);
              }
            })
            .catch((error) => {
              this.$message.error(error);
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
  },
  computed: {
    ...mapState(["imgurl"]),
  },
};
</script>


<style lang="less" scoped>
.information {
  background: url("/login/bg2.jpg") no-repeat;
  background-size: 100% 100%;
  height: 100vh;
  .info-container {
    margin: 0 auto;
    width: 75vw;
    padding: 10vh 0;
    box-sizing: border-box;

    .info-tab {
      margin-top: 40px;
    }
    .info-table {
      margin-top: 30px;
    }
  }
}

.breadcrumb-text /deep/ .el-breadcrumb__inner {
  color: #000000;
  font-size: 16px;
  background: #fff;
  padding: 5px 15px;
  box-sizing: border-box;
  border-radius: 5px;
}

// 搜索框
.search_box {
  margin-top: 40px;
  width: 25%;
  display: flex;
  align-items: center;
}
</style>

<style lang="less">
.tab-self /deep/ .el-tabs__nav-wrap::after {
  height: 0 !important;
}

.tab-self .el-tabs__item {
  width: 120px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  font-size: 16px;
  font-weight: bold;
}

.el-table--enable-row-transition {
  border-radius: 5px !important;
}

.el-tabs--card > .el-tabs__header .el-tabs__item.is-active {
  background-color: #2658ea;
}

.tab-self .el-tabs__item {
  border-bottom: 1px solid #e4e7ed !important;
  background: rgba(0, 0, 0, 0.3);
  color: #fff;
}

.tab-self .el-tabs__item:hover {
  // color: #2658EA;
  color: #fff;
}

.tab-self .el-tabs__item.is-active {
  color: #fff;
}

.el-tabs--card > .el-tabs__header {
  border-bottom: none !important;
}

// 底部分页
.info-pagination {
  margin-top: 40px;
}

// 分页默认样式
.el-pagination {
  display: flex;
  padding: unset !important;
}

.el-pagination.is-background .btn-next,
.el-pagination.is-background .btn-prev,
.el-pagination.is-background .el-pager li:first-child {
  margin-left: unset !important;
}
</style>
